
export const FETCH_SUBMITTED_FOR_VERIFICATION = "[MIS] FETCH_SUBMITTED_FOR_VERIFICATION";
export const FETCH_SUBMITTED_FOR_VERIFICATION_START = "[MIS] FETCH_SUBMITTED_FOR_VERIFICATION_START";
export const FETCH_SUBMITTED_FOR_VERIFICATION_SUCCESS = "[MIS] FETCH_SUBMITTED_FOR_VERIFICATION_SUCCESS";
export const FETCH_SUBMITTED_FOR_VERIFICATION_ERROR = "[MIS] FETCH_SUBMITTED_FOR_VERIFICATION_ERROR";

export const SET_MIS_SFV_FILTER = "[MIS] SET_MIS_SFV_FILTER";

export const SET_SFV_PAGINATION = "[MIS] SET_SFV_PAGINATION";
export const SET_SFV_AUTO_NEXT_VISIT = "[MIS] SET_SFV_AUTO_NEXT_VISIT";

export const VIEW_SFV_VISIT_LOADING_START = "[MIS] VIEW_SFV_VISIT_LOADING_START";
export const VIEW_SFV_VISIT_LOADING_END = "[MIS] VIEW_SFV_VISIT_LOADING_END";
export const RESET_SFV_FILTER = "[MIS] RESET_SFV_FILTER";

export const fetchSubmittedForVerification = (payload) => {
    return {
        type: FETCH_SUBMITTED_FOR_VERIFICATION,
        payload
    };
};

export const setMisSFVFilter = (searchFilter, sortConditions, skippedVisits) => {
    return {
        type: SET_MIS_SFV_FILTER,
        payload: {
            searchFilter,
            sortConditions,
            skippedVisits
        }
    };
}

export const setSfvAutoNextVisit = (autoNextVisit) => {
    return {
        type: SET_SFV_AUTO_NEXT_VISIT,
        autoNextVisit
    }
}

export const resetSFVFilter = () => {
    return {
        type: RESET_SFV_FILTER,
    };
}